module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-shadow-1.86df33f3.png";